import React, {useEffect, useState} from 'react';
import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {useDispatch, useSelector} from "react-redux";
import {loadingContracts, selectContracts} from "../../redux/reducers/contract-reducer.js";
import MobileDevicesTable from "../../components/MobileDevicesTable/MobileDevicesTable.jsx";
import {getDevices, partialUpdateDevice, selectDevices} from "../../redux/reducers/mobile-devices-reducer.js";

const MobileDevicesPage = () => {
    const {devices, loading: userLoading} = useSelector(selectDevices)
    const {contracts, loading: contractsLoading} = useSelector(selectContracts)

    const [contractOptions, setContractOptions] = useState([])

    const dispatch = useDispatch()

    const handleTableChange = (params) => {
        dispatch(partialUpdateDevice(params))
    }

    useEffect(() => {
        dispatch(loadingContracts)
        dispatch(getDevices)
    }, [dispatch])

    useEffect(() => {
        if (contracts.length > 0) {
            setContractOptions(contracts.map(contract => ({value: [contract.id], label: contract.name})))
        }
    }, [contracts])

    return (
        <CommonLayout>
            <Grid container direction={'column'}>
                <Grid item container alignItems={'center'}>
                    <Grid item>
                        <Typography variant={'h5'}>Мобильные устройства</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{height: '80vh'}}>
                    <MobileDevicesTable
                        devices={devices}
                        contracts={contractOptions}
                        loading={userLoading && contractsLoading}
                        onChange={handleTableChange}
                    />
                </Grid>
            </Grid>
        </CommonLayout>
    );
};

export default MobileDevicesPage;